export default function Avatar(theme) {
  const {
    palette: {
      primary: { dark, lighter, lightest, main }
    },
    typography
  } = theme;

  return {
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          color: dark,
          backgroundColor: lightest // grey[400]
        }
      }
    },
    MuiAvatarGroup: {
      styleOverrides: {
        avatar: {
          fontSize: '1rem',
          fontWeight: typography.fontWeightMedium,
          '&:first-of-type': {
            fontSize: '0.875rem',
            color: main,
            backgroundColor: lighter
          }
        }
      }
    }
  };
}
